import { render } from "./Attack.vue?vue&type=template&id=27cfebeb&scoped=true"
import script from "./Attack.vue?vue&type=script&lang=js"
export * from "./Attack.vue?vue&type=script&lang=js"

import "./Attack.vue?vue&type=style&index=0&id=27cfebeb&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cfebeb"]])

export default __exports__